import React from "react"
import types from "prop-types"
import StrikeAround from "shared/StrikeAround"
import { taskShape } from "utils/propTypeShapes"
import TaskCompletedTaskForm from "./TaskCompletedTaskForm"
import TaskOpenTaskForm from "./TaskOpenTaskForm"

const TaskSubform = ({ task, taskControls }) => {
  const { isOpen, subform } = task
  const { description, title } = subform

  return (
    <div className="w-full task-subform">
      <StrikeAround className="mb-2">
        <span className="text-dark font-medium text-xl">{ title }</span>
      </StrikeAround>
      <p className="text-dark text-sm text-center mb-6">{ description }</p>
      {
        isOpen
          ? <TaskOpenTaskForm task={task} taskControls={taskControls} />
          : <TaskCompletedTaskForm task={task} taskControls={taskControls} />
      }
    </div>
  )
}

TaskSubform.propTypes = {
  task: taskShape.isRequired,
  taskControls: types.node.isRequired,
}

export default TaskSubform
